module.exports = __webpack_public_path__ + "img/pexels-ylanite-koppens-3123915.522303db.jpg";